import React, { useState } from "react";
import { Container, Row, Col, Card, CardBody, Label, Input, FormFeedback } from "reactstrap";
import { Link, useHistory } from "react-router-dom";
import Breadcrumbs from "../../components/Common/Breadcrumb";
import { withTranslation } from "react-i18next";
import * as Yup from "yup";
import { useFormik } from "formik";
import Snackbars from "../../Utils/Snackbars";
import useRequests from '../../Utils/useRequests';

const Add_stky = (props) => {
  document.title = 'Add TTK';
  const history = useHistory();
  const { getRequest, postRequest } = useRequests();
  React.useEffect(() => {
    if (localStorage.getItem('admin_type') !== 'admin') {
      history.replace('/dashboard');
    }
  }, [history]);
  const [AlertData, setAlertData] = useState({ variant: '', message: '' });
  const [selectedLang, setSelectedLang] = useState("eng"); // dropdown selected language

  // Store data for both languages
  const [langData, setLangData] = useState({
    eng: { identified_hazard: "", preventive_controls: "", mitigative_controls	: "", control_lead: "" , energy_type: ""},
    es: { identified_hazard: "", preventive_controls: "", mitigative_controls	: "", control_lead: "" , energy_type: "" }
  });

  const resetAlertData = () => {
    setTimeout(() => {
      setAlertData({ variant: '', message: '' });
    }, 5000);
  };

  const validationSchema = Yup.object({
    identified_hazard: Yup.string().required("Identified Hazard is required"),
    preventive_controls: Yup.string().required(
      "Preventive Controls is required",
    ),
    mitigative_controls: Yup.string().required(
      "Mitigative Controls Type is required",
    ),
    control_lead: Yup.string().required("Control Lead is required"),
    energy_type: Yup.string().required("Energy Type is required"),
  })

  const formik = useFormik({
    enableReinitialize: true,
    initialValues: {
      identified_hazard: langData.eng.identified_hazard,
      preventive_controls: langData.eng.preventive_controls,
      mitigative_controls: langData.eng.mitigative_controls,
      control_lead: langData.eng.control_lead,
      energy_type: langData.eng.energy_type,
    },
    validationSchema,
    onSubmit: async () => {
      try {
        const payload = [
          { 
            lang: localStorage.getItem("I18N_LANGUAGE"),
            identified_hazard: langData.eng.identified_hazard,
            preventive_controls: langData.eng.preventive_controls,
            mitigative_controls: langData.eng.mitigative_controls,
            control_lead: langData.eng.control_lead,
            et_id: langData.eng.energy_type,
          },
        ];

        let submit1 = document.getElementById('submit1');
        submit1.disabled = true;
        submit1.textContent = 'Processing...';

        const res = await postRequest('add-stky', JSON.stringify(payload));
        if (res && res.code === 200) {
          history.push({
            pathname: '/stky',
            state: { code: 200, status: 'success', message: res.message }
          });
        } else {
          setAlertData({ variant: 'error', message: res.message });
        }
        resetAlertData();
        submit1.disabled = false;
        submit1.textContent = 'Submit';
      } catch (error) {
        console.error("Error: ", error);
      }
    }
  });

  const handleLangChange = (lang) => {
    setSelectedLang(lang);
  };

  const handleFieldChange = (e) => {
    const { name, value } = e.target;
    const currentLang = selectedLang;
    setLangData((prev) => ({
      ...prev,
      [currentLang]: { ...prev[currentLang], [name]: value }
    }));
    formik.setFieldValue(
      `${currentLang}${name.charAt(0).toUpperCase() + name.slice(1)}`,
      value
    );
  };

  const [EnergyTypesData, setEnergyTypesData] = React.useState([]);
  const handleLoadGetEnergyTypes = async () => {
    const res = await getRequest('get-energy-types');
    if (res && res.code === 200) {
      let originalText = res.data;
      originalText.forEach(element => {
        if(localStorage.getItem("I18N_LANGUAGE") == "eng") {
          element.name = element.title;
        }else{
          element.name = element.title_sp;
        }
      });
      setEnergyTypesData(originalText);
    }
    else {

      setEnergyTypesData([]);

      setAlertData((AlertData) => ({
        ...AlertData,
        variant: 'error',
        message: res.message,
      }));
    }
    resetAlertData();
  }

    React.useEffect(() => {
      handleLoadGetEnergyTypes();
    }, []);

  return (
    <React.Fragment>
      {AlertData.message && <Snackbars variant={AlertData.variant} message={AlertData.message} />}
      <div className="page-content">
        <Container fluid>
          <Breadcrumbs title={props.t("Utilize Safety")} breadcrumbItem={props.t("Add TTK")} />
          <Card>
            <CardBody>
              {/* <Row>
                <Col md={4}>
                  <Label className="form-label">Select Language:</Label>
                  <Input
                    type="select"
                    value={selectedLang}
                    onChange={(e) => handleLangChange(e.target.value)}
                  >
                    <option value="eng">English</option>
                    <option value="es">Spanish</option>
                  </Input>
                </Col>
              </Row> */}
              <Row className="mt-3">
                <Col md={6}>
                  <div className="mb-3">
                    <Label className="form-label">
                      Energy Type :
                    </Label>
                    <Input
                      type="select"
                      name="energy_type"
                      value={langData[selectedLang].energy_type}
                      onChange={handleFieldChange}
                      onBlur={formik.handleBlur}
                      invalid={
                        formik.touched.energy_type && formik.errors.energy_type ? true : false
                      }
                    >
                      <option value="">Select Energy Type</option>
                      {EnergyTypesData.map((item, index) => (
                        <option key={index} value={item.et_id}>
                          {item.name}
                        </option>
                      ))}
                    </Input>
                    {formik.touched.energy_type && formik.errors.energy_type && (
                      <FormFeedback type="invalid">
                        {formik.errors.energy_type}
                      </FormFeedback>
                    )}
                  </div>
                </Col>

                <Col md={6}>
                  <div className="mb-3">
                    <Label className="form-label">
                      Identified Hazard :
                    </Label>
                    <Input
                      name="identified_hazard"
                      type="textarea"
                      rows={4}
                      placeholder={`Enter Identified Hazard (${localStorage.getItem("I18N_LANGUAGE").toUpperCase()})`}
                      value={langData[selectedLang].identified_hazard}
                      onChange={handleFieldChange}
                      onBlur={formik.handleBlur}
                      invalid={
                        formik.touched.identified_hazard &&
                        formik.errors.identified_hazard
                          ? true
                          : false
                      }
                    />
                    {formik.touched.identified_hazard &&
                      formik.errors.identified_hazard && (
                        <FormFeedback type="invalid">
                          {formik.errors.identified_hazard}
                        </FormFeedback>
                      )}
                  </div>
                </Col>

                <Col md={6}>
                  <div className="mb-3">
                    <Label className="form-label">
                      Preventive Controls :
                    </Label>
                    <Input
                      name="preventive_controls"
                      type="textarea"
                      rows={4}
                      placeholder={`Enter Preventive Controls (${localStorage.getItem("I18N_LANGUAGE").toUpperCase()})`}
                      value={langData[selectedLang].preventive_controls}
                      onChange={handleFieldChange}
                      onBlur={formik.handleBlur}
                      invalid={
                        formik.touched.preventive_controls &&
                        formik.errors.preventive_controls
                          ? true
                          : false
                      }
                    />
                    {formik.touched.preventive_controls &&
                      formik.errors.preventive_controls && (
                        <FormFeedback type="invalid">
                          {formik.errors.preventive_controls}
                        </FormFeedback>
                      )}
                  </div>
                </Col>

                <Col md={6}>
                  <div className="mb-3">
                    <Label className="form-label">
                      Mitigative Controls :
                    </Label>
                    <Input
                      name="mitigative_controls"
                      type="textarea"
                      rows={4}
                      placeholder={`Enter Mitigative Controls (${localStorage.getItem("I18N_LANGUAGE").toUpperCase()})`}
                      value={langData[selectedLang].mitigative_controls}
                      onChange={handleFieldChange}
                      onBlur={formik.handleBlur}
                      invalid={
                        formik.touched.mitigative_controls &&
                        formik.errors.mitigative_controls
                          ? true
                          : false
                      }
                    />
                    {formik.touched.mitigative_controls &&
                      formik.errors.mitigative_controls && (
                        <FormFeedback type="invalid">
                          {formik.errors.mitigative_controls}
                        </FormFeedback>
                      )}
                  </div>
                </Col>


                <Col md={6}>
                  <div className="mb-3">
                    <Label className="form-label">
                      Control Lead :
                    </Label>
                    <Input
                      name="control_lead"
                      type="textarea"
                      rows={4}
                      placeholder={`Enter Control Lead (${localStorage.getItem("I18N_LANGUAGE").toUpperCase()})`}
                      value={langData[selectedLang].control_lead}
                      onChange={handleFieldChange}
                      onBlur={formik.handleBlur}
                      invalid={
                        formik.touched.control_lead &&
                        formik.errors.control_lead
                          ? true
                          : false
                      }
                    />
                    {formik.touched.control_lead &&
                      formik.errors.control_lead && (
                        <FormFeedback type="invalid">
                          {formik.errors.control_lead}
                        </FormFeedback>
                      )}
                  </div>
                </Col>
              </Row>
              <div className="text-left mt-2">
                <button
                  type="button"
                  id="submit1"
                  onClick={(e) => {
                    e.preventDefault();
                    formik.handleSubmit();
                  }}
                  className="btn btn-primary me-2"
                >
                  Submit
                </button>
                <Link to="/stky" className="btn btn-light me-2">Cancel</Link>
              </div>
            </CardBody>
          </Card>
        </Container>
      </div>
    </React.Fragment>
  );
};

export default withTranslation()(Add_stky);
